import React, { useState } from "react";

import { Dialog, Button, Input, Form } from "element-react";
import Loader from "components/loader.tsx";

const RjectButton = ({ row, title, handleSave, status }) => {
  const [isVisible, setVisible] = useState(false);
  const [state, setState] = useState({ remarks: "", isLoading: false });
  const closeModal = () => {
    setVisible(false);
  };
  const onSave = async (e) => {
    var param = { status, articleId: row.Id, remarks: state.remarks };
    await handleSave(param);
    closeModal();
  };
  return (
    <>
      <Button size="mini" onClick={() => setVisible(true)}>
        {title}
      </Button>
      {isVisible && (
        <Dialog
          title="Are you sure, you want to reject this article?"
          visible={isVisible}
          onCancel={closeModal}
          style={{ width: "450px" }}
        >
          <Dialog.Body>
            <Loader isLoading={state.isLoading}>
              <div>
                <Form>
                  <Form.Item>
                    <label>
                      By rejecting this article, you won't be able to proceed
                      any further action.
                    </label>
                  </Form.Item>
                  <Form.Item label="Remarks">
                    <Input
                      type="textarea"
                      placeholder="Remarks"
                      value={state.remarks}
                      onChange={(val: any) =>
                        setState({ ...state, remarks: val })
                      }
                    ></Input>
                  </Form.Item>
                  <div className="flex-end">
                    <Button type="primary" onClick={onSave}>
                      Ok
                    </Button>
                  </div>
                </Form>
              </div>
            </Loader>
          </Dialog.Body>
        </Dialog>
      )}
    </>
  );
};
export default RjectButton;
